import { generatePath, useHistory } from 'react-router'
import { ChatTypeEnum } from '@medentee/enums'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'services/query'
import { Button, ConfirmationModal } from 'App/components/common'
import { leaveGroupChat } from 'api/chats'
import { getChatRoomsRequest, hideModalAction, useAppDispatch, useAppSelector } from 'store'
import { CHAT_PATH, EChatTypeMap } from 'globalConstants'

type TLeaveChatConfirmProps = {
  chatId: string
}

export const LeaveChatConfirm = ({ chatId }: TLeaveChatConfirmProps) => {
  const dispatch = useAppDispatch()

  const { t } = useTranslation()

  const { page, showBy } = useAppSelector((state) => state.chat.chatRooms.filters)

  const { push } = useHistory()

  const { mutate: leaveChat, isLoading } = useMutation({
    mutationKey: ['leave-group-chat'],
    mutationFn: leaveGroupChat,
    onSuccess: () => {
      push(generatePath(CHAT_PATH, { chatType: EChatTypeMap.DIALOGUE }))
      dispatch(hideModalAction())
      dispatch(getChatRoomsRequest({ chatType: [ChatTypeEnum.DIALOGUE], page, showBy }))
    }
  })

  const handleClick = () => {
    leaveChat(chatId)
  }

  return (
    <ConfirmationModal
      content={t('modal.leaveChatConfirm.content')}
      controls={
        <Button loading={isLoading} disabled={isLoading} onClick={handleClick}>
          {t('modal.leaveChatConfirm.submitButton')}
        </Button>
      }
    />
  )
}
